import { AccountCircle, Logout, SwitchAccount } from '@mui/icons-material';
import { Avatar, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { getAuth } from 'firebase/auth';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { UserType } from '../consts/types/general';
import { AuthSelectors } from '../reducers/auth';
import { EmployerSelectors } from '../reducers/employer';
import { UserSelectors } from '../reducers/user';

interface UserAvatarProps {

}

type Props = UserAvatarProps;


const UserAvatar: FC<Props> = (props: Props) => {
    const navigate = useNavigate();
    const user = useSelector(UserSelectors.currentUser);
    const employer = useSelector(EmployerSelectors.currentEmployer);
    const userType = useSelector(AuthSelectors.currentUserType);
    const authenticating = useSelector(UserSelectors.authenticating);
    const photoURL = useSelector(UserSelectors.photoURL);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const authUser = userType === UserType.User ? user : employer;
    if (!authenticating && authUser) {

        return <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <IconButton
                    onClick={handleClick}
                    size="small"
                    sx={{ ml: 2 }}
                    aria-controls={open ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <Avatar sx={{ width: 28, height: 28, fontSize: "14px", backgroundColor: "#f26b4d", color: "white" }} alt='authUser avatar' src={photoURL || undefined}>
                        {!photoURL && `${(authUser.name || authUser.email || "").split(' ')[0][0]}${((authUser.name || authUser.email || "").split(' ')[1] || [""])[0]}`}
                    </Avatar>
                </IconButton>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 28,
                            height: 28,
                            // ml: 1,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <Box display="flex" alignItems="center" mt={1} mb={2} px={2} gap={1}>
                    <Avatar sx={{ fontSize: "14px", backgroundColor: "#f26b4d", color: "white" }} alt='authUser avatar' src={photoURL || undefined}>
                        {!photoURL && `${(authUser.name || authUser.email || "").split(' ')[0][0]}${((authUser.name || authUser.email || "").split(' ')[1] || [""])[0]}`}
                    </Avatar>
                    <Box>
                        <Typography fontSize={{ xs: "0.9rem", md: "0.95rem" }} >{authUser.name}</Typography>
                        <Typography fontSize={{ xs: "0.8rem", md: "0.85rem" }} color="text.secondary">{authUser.email}</Typography>
                    </Box>
                </Box>
                {/* <Divider /> */}
                <MenuItem sx={{ mt: 1, fontSize: { xs: "0.9rem", md: "0.95rem" } }} onClick={() => {
                    navigate(userType === UserType.User ? "/user" : "/employer/find");
                    handleClose();
                }} >
                    <ListItemIcon>
                        {userType === UserType.User && <AccountCircle />}
                        {userType === UserType.Employer && <SwitchAccount />}
                    </ListItemIcon>
                    {userType === UserType.Employer ? "Find Candidates" : "Dashboard"}
                </MenuItem>
                {userType === UserType.Employer && <MenuItem sx={{ mt: 1, fontSize: { xs: "0.9rem", md: "0.95rem" } }} onClick={() => {
                    navigate("/employer/profile");
                    handleClose();
                }} >
                    <ListItemIcon>
                        <AccountCircle fontSize="medium"/>
                    </ListItemIcon>
                    Profile
                </MenuItem>}
                <Divider />
                <MenuItem sx={{ fontSize: { xs: "0.9rem", md: "0.95rem" } }} onClick={() => {
                    getAuth().signOut().catch(() => { });
                    handleClose();
                }} >
                    <ListItemIcon>
                        <Logout fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </React.Fragment >
    }

    return null;
}


export default UserAvatar;

